import { BadgeType } from '@/components/view/atoms/badge/Badge'

// 記事承認ステータスの表示ラベル
export const articleApprovalStatusLabel = (status: string | null): string => {
  switch (status) {
    case 'pending':
      return '承認待ち'
    case 'upload_ready':
      return 'アップロード対象'
    case 'rejected':
      return '却下'
    case 'cancelled':
      return 'キャンセル'
    case 'uploaded':
      return 'アップロード済み'
    default:
      return status ?? '-'
  }
}

// 記事承認ステータスのバッジ種別
export const articleApprovalStatusBadgeType = (status: string | null): BadgeType => {
  switch (status) {
    case 'pending':
      return BadgeType.CAUTION
    case 'upload_ready':
      return BadgeType.SUCCESS
    case 'rejected':
      return BadgeType.CRITICAL
    case 'uploaded':
      return BadgeType.EMPHASIS
    case 'cancelled':
    default:
      return BadgeType.DEFAULT
  }
}
